import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import logo from "../../../sidebar-logo.png";
import userStore from "../../../Stores/User";
import { isProPlan } from "../../../constants/plans";

const MobileHeader = observer(({ mobileMode, search }) => {
  const displayText =
    mobileMode === "addArticle"
      ? "Add Article"
      : mobileMode === "settings"
      ? "Other"
      : mobileMode === "playlist"
      ? "Playlist"
      : search.trim().length > 0
      ? "Search"
      : "Feeds";

  const hasPlan = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id;
  const isPro = userStore.user?.subscriptions?.raw_subscriptions?.[0]?.plan?.id 
    ? isProPlan(userStore.user.subscriptions.raw_subscriptions[0].plan.id)
    : false;

  const badgeStyle = {
    padding: "2px 6px",
    borderRadius: "8px",
    fontSize: "11px",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
    width: isPro ? "45px" : "95px",
    whiteSpace: "nowrap",
    background: isPro === undefined || hasPlan === undefined
      ? ''
      : isPro
      ? 'linear-gradient(135deg, #CB5EEE 0%, #4BE1EC 100%)' 
      : hasPlan
      ? 'linear-gradient(135deg, #FFB347 0%, #FFCC33 100%)'
      : 'linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)',
    margin: "60px auto 0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  const handleBadgeClick = () => {
    if (!isPro) {
      if (hasPlan) {
        window.Stripe?.redirectToCustomerPortal();
      } else {
        window.location.href = "/onboarding/ChooseVoice";
      }
    }
  };

  return (
    <div style={{ textAlign: "center" }}>
      <div style={{ 
        display: "flex", 
        flexDirection: "column",
        alignItems: "center"
      }}>
        <img src={logo} className="logo" />
        <div style={badgeStyle} onClick={handleBadgeClick}>
          {isPro === undefined || hasPlan === undefined ? "" : !isPro && !hasPlan ? "UPGRADE" : isPro ? "PRO" : "UPGRADE"}
        </div>
      </div>
      <div className="display-text">{displayText}</div>
    </div>
  );
});

export default MobileHeader;
